/* tslint:disable */

/**
 */
export class Denomination {
    id?: number;
    price?: number;
    type?: string;
    color?: string;
    is_hidden?: boolean;
}
